export default "__VITE_ASSET__Ztc2DAcd32aL6aTjnxoJSQ__"